/** Dock panel sizes (px) — drag-resize + persist. */

export const PATTERNS_WIDTH_DEFAULT = 440;
export const PATTERNS_WIDTH_MIN = 260;
export const PATTERNS_WIDTH_MAX = 720;

export const INSTRUMENT_WIDTH_DEFAULT = 320;
export const INSTRUMENT_WIDTH_MIN = 240;
export const INSTRUMENT_WIDTH_MAX = 560;

export const FX_HEIGHT_DEFAULT = 220;
export const FX_HEIGHT_MIN = 140;
export const FX_HEIGHT_MAX = 480;

function clampSize(raw: unknown, min: number, max: number, fallback: number): number {
  const n = typeof raw === "number" ? raw : Number(raw);
  if (!Number.isFinite(n)) {
    return fallback;
  }
  return Math.min(max, Math.max(min, Math.round(n)));
}

export function clampPatternsWidth(raw: unknown, fallback = PATTERNS_WIDTH_DEFAULT): number {
  return clampSize(raw, PATTERNS_WIDTH_MIN, PATTERNS_WIDTH_MAX, fallback);
}

export function clampInstrumentWidth(raw: unknown, fallback = INSTRUMENT_WIDTH_DEFAULT): number {
  return clampSize(raw, INSTRUMENT_WIDTH_MIN, INSTRUMENT_WIDTH_MAX, fallback);
}

export function clampFxHeight(raw: unknown, fallback = FX_HEIGHT_DEFAULT): number {
  return clampSize(raw, FX_HEIGHT_MIN, FX_HEIGHT_MAX, fallback);
}
